import { SET_THANK_YOU_REDIRECT_URL } from 'actions';

export function setThankYouRedirectUrl(url: string) {
  return { type: SET_THANK_YOU_REDIRECT_URL, url };
}
